var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.6375V12.5575C21.9988 14.7139 21.3005 16.8122 20.0093 18.5393C18.7182 20.2665 16.9033 21.53 14.8354 22.1414C12.7674 22.7528 10.5573 22.6794 8.53447 21.9321C6.51168 21.1847 4.78465 19.8036 3.61096 17.9945C2.43727 16.1855 1.87979 14.0455 2.02168 11.8938C2.16356 9.74205 2.99721 7.69381 4.39828 6.05455C5.79935 4.4153 7.69279 3.27286 9.79619 2.79763C11.8996 2.32239 14.1003 2.53982 16.07 3.41748",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.55762L12 14.5676L9 11.5676",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.efe0beb3a094026c47a9882ecbd23a5d.svg";
export { ForwardRef as ReactComponent };